






































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { doublePrevention } from '@/api/installServer';
import ResultDepartDialog from '@/views/doublePrevention/hazardDepartConfig/resultDepartDialog.vue';

@Component({
  components: { ResultDepartDialog },
  mixins: [TableStripe],
})
export default class HazardDepartConfig extends Vue {
  private tableData: any = [];

  private getTableData() {
    doublePrevention.getHazardLevelDepartmentConfigAll().then((res: any) => {
      if (res.code === '200') {
        this.tableData = res.data;
      } else {
        this.$message.warning('获取隐患部门配置表数据失败！');
      }
    });
  }

  private doSomeThing(data: any, type: string) {
    const passData: any = {
      data: data,
      type: type,
    };
    // console.log(data);
    // (this.$refs.departDialog as any).showDialog(passData);
    (this.$refs.resultDepartDialog as any).showDialog(passData);
  }

  created() {
    this.getTableData();
  }

  /**
   *【排班方案编辑窗口】排班方案编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handleStaffEditResponse(res: any) {
    // if (res.index < 0) {
    //   if (res.staff.length > 0) {
    //     this.planDetail.scheduleOrderInfo.push({
    //       staffList: res.staff,
    //     });
    //   }
    // } else {
    //   this.planDetail.scheduleOrderInfo[res.index].staffList = res.staff;
    // }
  }
}
